<form [formGroup]="formData" class="text-start">
  @for (item of controlsData; track item; let i = $index; let last = $last) {
    <div class="mb-3 row">
      <div class="col-sm-12 mb-2">
        @if (item.label && isQuePage) {
          <label [for]="item.name" class="col-sm-12">
            <span>{{ i + 1 }}. &nbsp;</span><span class="dynamic-content title" #contentDiv [innerHtml]="item.label"></span>
          </label>
        }
        @if (item.label && !isQuePage) {
          <label class="col-sm-12" [for]="item.name">
            <span class="col-form-label title" [innerHtml]="item.label"></span>
            @if (item.options?.helpText && item.name.toLowerCase().includes('phone')) {
              <span class="col-sm-2 fs-14">&nbsp;({{item.options?.helpText}})</span>
            }
            @if (item.validators.required || item.required) {
              <span class="col-sm-2 fs-14">&nbsp;(Required)</span>
            }
          </label>
        }
        @if (!item.label && item.type!='hidden') {
          <label [for]="item.name" class="col-sm-12">
            <span class="col-form-label title">Enter the text</span>
            @if (item.validators.required || item.required) {
              <span class="fs-14">&nbsp;(Required)</span>
            }
          </label>
        }
        @if (item.options?.helpText != null && !item.name.toLowerCase().includes('phone')) {
          <div class="col-sm-12">
            <span class="col-sm-2 fs-14" [innerHtml]="item.options?.helpText"></span>
          </div>
        }
        @if (typeof(item.helpText) !== 'undefined' && item.helpText !== null && !item.name.toLowerCase().includes('phone')) {
          <div class="col-sm-12">
            <span class="col-sm-2 fs-14" [innerHtml]="item.helpText"></span>
          </div>
        }
      </div>
      <div class="col-sm-12" [ngClass]="customClass">
        @if (['text', 'password', 'search', 'url'].includes(item.type)) {
          <input
            [placeholder]="item.placeholder ? item.placeholder : ''" [type]="item.type" [formControlName]="item.name"
            class="form-control" [id]="item.name" [name]="item.name" [value]="item.value" [(ngModel)]="item.value"
            [attr.maxlength]="item.validators.maxLength" (change)="modelChangeEvent($event, item)" aria-label="Text" />
        }
        @if (item.type === 'email') {
          <input  [placeholder]="item.placeholder ? item.placeholder : ''" type="email" [formControlName]="item.name"
            class="form-control" [id]="item.name" [name]="item.name" [readonly]="item.readonly === true"/>
        }
        @if (item.type === 'email' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched && formData.get(item.name)?.value) {
          <span
          class="error validation-color"> Enter a valid email. Example: email&#64;example.com</span>
        }
        @if (item.type === 'number') {
          <input [placeholder]="item.placeholder ? item.placeholder : ''" type="text"
            appNumberOnly [formControlName]="item.name" class="form-control" [id]="item.name" [name]="item.name"
            [value]="item.value" [ngModel]="item.value" [minlength]="item?.options?.minLength ?? 0"
            [maxlength]="item?.options?.maxLength ?? 250" pattern="[0-9]*" (ngModelChange)="modelChangeEvent($event, item)"
            aria-label="Number" />
        }
        @if (item.type === 'currency') {
          <input [placeholder]="item.placeholder ? item.placeholder : ''" type="text"
            appCurrency maxDigits="9" pattern="^(?![0,.]+$)(?:0|[1-9]\d{0,2}(?:,\d{3})*|[1-9]\d*)(?:\.\d{1,2})?$"
            [formControlName]="item.name" class="form-control" [id]="item.name" [name]="item.name" [value]="item.value"
            [ngModel]="item.value" [minlength]="item?.options?.minLength ?? 0" [maxlength]="item?.options?.maxLength ?? 250"
            (ngModelChange)="modelChangeEvent($event, item)" aria-label="Currency" autocomplete="off" />
        }
        @if (item.type === 'zip') {
          <input type="text" appZip [formControlName]="item.name" class="form-control" [id]="item.name"
            [name]="item.name" aria-label="Zip Code"/>
        }
        @if (item.type === 'zip' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched && formData.get(item.name)?.value) {
          <span class="error validation-color">
          Not valid. Use 5 or 9 digits (e.g., 12345 or 12345-6789) </span>
        }
        @if (item.type === 'ssn') {
          <input type="text" appSsn [formControlName]="item.name" class="form-control" [id]="item.name"
            [name]="item.name" aria-label="SSN" />
        }
        @if (item.type === 'ssn' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched && formData.get(item.name)?.value) {
          <span class="error validation-color">
          Not valid, use 9 digits in format 111-22-3333</span>
        }
        @if (item.type === 'fax') {
          <input type="text" appFax [formControlName]="item.name" class="form-control" [id]="item.name"
            [name]="item.name" placeholder="123-456-7890" aria-label="Fax Number"/>
        }
        @if (item.type === 'fax' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched) {
          <span class="error validation-color">
            Not valid. Use 10-digit number (e.g., 123-456-7890)
          </span>
        }
        @if (item.type === 'date') {
          <span class="dateFieldOnlineReferrals">
            <p-datepicker
              placeholder="MM/DD/YYYY"
              [formControlName]="item.name"
              [id]="item.name"
              [(ngModel)]="item.value"
              [minDate]="item.options.min"
              [maxDate]="item.options.max"
              (input)="formatDateToMMDDYYYY($event, item); onDateInput($event);modelChangeEvent($event, item)"
              (onClearClick)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
              (onSelect)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
              [showButtonBar]="true"
              [showIcon]="true"
              [showOnFocus]="false"
              (click)="onCalendarClick()"
              [ngClass]="{'is-invalid': formData.get(item.name)?.invalid && formData.get(item.name)?.touched}"
              inputStyleClass="form-control">
            </p-datepicker>
            <br />
            <span [id]="item.name+'_Error'" style="color: red;"></span>
            @if (formData.get(item.name)?.errors?.['dateRangeInvalid']) {
              <span class="error validation-color">
                {{ formData.get(item.name)?.errors?.['dateRangeInvalid']?.message }}
              </span>
            }
          </span>
        }
        @if (item.type === 'phone') {
          <input type="tel" [formControlName]="item.name" class="form-control"
            [id]="item.name" [name]="item.name" [value]="item.value" [ngModel]="item.value"
            (ngModelChange)="modelChangeEvent($event, item)" aria-label="Phone" />
        }
        @if (item.type === 'select') {
          <select [ngClass]="controlWidth ? 'form-select width45p' : 'form-select'"
            [formControlName]="item.name" aria-label="Default select example" [id]="item.name" [(ngModel)]="item.value"
            (change)="modelChangeEvent($event, item)" [name]="item.name">
            <option value="" disabled selected>Select an option</option>
            @for (option of item.options; track option) {
              <option [value]="option.value">
                {{ option.key }}
              </option>
            }
          </select>
        }
        @if (item.type === 'textarea') {
          <textarea class="form-control"
            [placeholder]="item.placeholder ? item.placeholder : ''" [formControlName]="item.name" [id]="item.name"
        [name]="item.name" [(ngModel)]="item.value" (ngModelChange)="modelChangeEvent($event, item)" [maxlength]="
          item.validators.maxLength ? item.validators.maxLength : null
        " [cols]="textAreaCol" [rows]="textAreaRows" aria-label="textArea"></textarea>
        }
        @if (item.type === 'textarea' && item?.options.showCount) {
          <span class="fs-14" [ngClass]="textAreaCounterPositionClass"
            style="padding-top: 3px;">Character space remaining:
          {{ item.options.count | number }}</span>
        }
        @if (item.type=='hidden') {
          <input type="hidden" [formControlName]="item.name" class="form-control"
            [id]="item.name" [name]="item.name" [value]="item.value" [(ngModel)]="item.value"
            (change)="modelChangeEvent($event, item)" aria-label="Text" />
        }
      </div>
      <div class="col-sm-2">
        @if (item.helperText) {
          <span class="fs-14">{{ item.helperText }}</span>
        }
      </div>
      @if (isQuePage) {
        <hr class="mt-4" />
      }
    </div>
  }
</form>